module.exports = __webpack_public_path__ + "static/media/quizBadgeLevel4Locked.8e3e9fe5.png";